<template>
<div>
  <div v-show="!done" class="mdl-grid">
    <div class="mdl-cell mdl-cell--4-col mdl-cell--12-col-tablet">
      <div class="mdl-card fill mdl-shadow--2dp ga-tall-card">
        <div class="mdl-tabs mdl-js-tabs">
          <div class="mdl-tabs__tab-bar ga-form-title">
            <a href="#detailsTab1" class="mdl-tabs__tab is-active">{{'newDelayed.label.details' | label}}</a>
            <a href="#faq" class="mdl-tabs__tab">{{'newDelayed.label.faq' | label}}</a>
          </div>
          <div class="mdl-tabs__panel is-active" id="detailsTab1">
            <delayed-details :tab="tab" scroll></delayed-details>
          </div>
          <div class="mdl-tabs__panel" id="faq">
            <faq service="delayed"></faq>
          </div>
        </div>
      </div>
    </div>
    <div class="mdl-cell mdl-cell--8-col">
      <register-form with-credentials></register-form>
    </div>
  </div>

  <div v-show="done" class="card-page-container"  >
    <div class="mdl-grid">
      <div class="mdl-layout-spacer"></div>
      <div class="mdl-cell fill mdl-shadow--2dp">
        <alert title="register.verify.message.title" message="register.verify.message.text" goto="/"></alert>
      </div>
      <div class="mdl-layout-spacer"></div>
    </div>
  </div>
</div>
</template>

<script>
  var local = require('common/store/local')
  var auth = require('api/Auth')
  var actions = require('common/store/actions')
  module.exports = {
    ready: function () {
      window.componentHandler.upgradeAllRegistered()
      if (location.href.includes('?lang=')) {
        let split = location.href.split('?lang=').pop()
        if (local.get('client.language') !== split) {
          this.changeLanguage(split)
        }
      }
    },
    vuex: {
      actions: actions
    },
    methods: {
      onError: function (err) {
        this.$dispatch('loading', false)
        if (err.data.message === 'register.error.usernameExists') {
          this.$broadcast('username-validation-fail', 'register.error.usernameExists')
        } else if (err.data.message === 'register.validation.password') {
          this.$broadcast('password-validation-fail', 'register.validation.password')
        } else if (err.data.message === 'register.validation.confirmPassword') {
          this.$broadcast('confirm-password-validation-fail', 'register.validation.confirmPassword')
        } else {
          this.$dispatch('show-error', err)
        }
      }
    },
    components: {
      registerForm: require('c/forms/RegisterForm'),
      'delayed-details': require('c/segments/DelayedDetails'),
      'faq': require('c/segments/FAQ'),
      alert: require('c/components/Alert')
    },
    events: {
      'registration-valid': function (user) {
        this.user = user
        var self = this
        this.$dispatch('loading', true)
        auth.register(this.user, function (user, authData) {
          self.done = true
          self.$dispatch('loading', false)
        }, this.onError)
      }
    },
    data: function () {
      return {
        tab: '0',
        user: {},
        done: false
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// Register.vue?c7b3c0d0